import store from '@/store';
import { SECTION_SUFFIX } from '@/constants';
import Section from '../../entities/Section';
import { getAllLayers } from './common';
var updateCreatedSectionSmart = function (props) {
    var section = props.section, group = props.group, _a = props.ribbonColor, ribbonColor = _a === void 0 ? null : _a, _b = props.paperColor, paperColor = _b === void 0 ? null : _b;
    if (group === null || group === void 0 ? void 0 : group.textStyle) {
        var _c = group.textStyle, text_height = _c.text_height, bold = _c.bold, italic = _c.italic, color = _c.color, transforms = _c.transforms;
        if (!isNaN(text_height)) {
            section.setFontSize(text_height);
        }
        section.setBold(bold);
        section.setItalic(italic);
        if (color) {
            section.setFontColor(color);
        }
        if (transforms && !isNaN(transforms.angle)) {
            section.setAngle(transforms.angle);
        }
    }
    if (ribbonColor) {
        section
            .setFontColor(ribbonColor)
            .setGlyphFillColor(ribbonColor)
            .setBarcodeColor(ribbonColor)
            .setShapeStokeColor(ribbonColor)
            .setShapeFillColor(ribbonColor);
    }
    if (paperColor) {
        section.setBackgroundState(true).setFillColor(paperColor);
    }
    return section;
};
export var createSectionSmart = function (data) {
    var sourceShield = data.sourceShield, pages = data.pages, _a = data.ribbonColor, ribbonColor = _a === void 0 ? null : _a, _b = data.paperColor, paperColor = _b === void 0 ? null : _b;
    // support only rect shield to section
    var $x = sourceShield.primitiveProps.hasOwnProperty('x');
    var $y = sourceShield.primitiveProps.hasOwnProperty('y');
    var $w = sourceShield.primitiveProps.hasOwnProperty('w');
    var $h = sourceShield.primitiveProps.hasOwnProperty('h');
    if (!$x || !$y || !$w || !$h) {
        console.error('Support only rect shield for section');
        return null;
    }
    var _c = getAllLayers(sourceShield.id, pages), group = _c.group, page = _c.page;
    var shieldId = sourceShield.id, _d = sourceShield.primitiveProps, x = _d.x, y = _d.y, w = _d.w, h = _d.h;
    var sectionId = createSectionId({ shieldId: shieldId, page: page });
    var secToAppend = new Section({ x: x, y: y, width: w, height: h, id: sectionId, shieldId: shieldId });
    return updateCreatedSectionSmart({ section: secToAppend, group: group, ribbonColor: ribbonColor, paperColor: paperColor });
};
export var updateCreatedSection = function (section) {
    var _a = store.getState().core, ribbonColor = _a.ribbonColor, paperColor = _a.paperColor, pages = _a.pages;
    var group = getAllLayers(section.id, pages).group;
    return updateCreatedSectionSmart({ section: section, group: group, ribbonColor: ribbonColor, paperColor: paperColor });
};
var createSectionId = function (_a) {
    var shieldId = _a.shieldId, page = _a.page;
    var maxNum = 0;
    if (page) {
        for (var sectionId in page.sections) {
            var section = page.sections[sectionId];
            var num = parseInt(section.id.split(SECTION_SUFFIX)[1]) + 1;
            if (num > maxNum) {
                maxNum = num;
            }
        }
    }
    return "".concat(shieldId).concat(SECTION_SUFFIX).concat(maxNum);
};
